import React from 'react';

import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import type { BrokerOption } from '../types';
import type { Filters, SelectOption } from './types';
import UserIcon from 'components/user_icon';

type Slice = Pick<Filters, 'brokers'>;
interface Props extends Slice {
  brokerOptions: BrokerOption[];
  onChange: (changes: Slice) => void;
}

function getBrokerOption(broker: BrokerOption): SelectOption {
  return {
    label: (
      <div className="d-flex align-items-center py-1 gap-1">
        {broker.imageUrl ? (
          <UserIcon size="sm" user={broker} />
        ) : (
          <FontAwesomeIcon className="text-muted" icon={faUsers} />
        )}
        {broker.name}
      </div>
    ),
    value: broker.id.toString(),
  };
}

export default function ActivityBrokerFilter({ brokers, brokerOptions, onChange }: Props) {
  return (
    <CheckboxFilter
      addFilter={(_name, filter) => onChange({ brokers: [...brokers, filter] })}
      hideClearControl={!brokers.length}
      hideSelectedCount={!brokers.length}
      label="Broker"
      options={brokerOptions.map(getBrokerOption)}
      removeFilter={(_name, filter) => onChange({ brokers: brokers.filter(t => t !== filter) })}
      selected={brokers}
      onClear={() => onChange({ brokers: [] })}
    />
  );
}
